import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Button, Icon, Loader, Pagination } from "semantic-ui-react";
import Filter from "../../components/layout/Testimonials/Filter";
import TestimonialCard from "../../components/layout/Testimonials/Card";
import Add from "../../components/layout/Testimonials/Add";
const SuperSchoolsWatch = (props) => {
  const [totalPages, setTotalPages] = useState(1);
  const [activePage, setActivePage] = useState(1);
  const [data, setData] = useState([]);
  const [part1, setPart1] = useState([]);
  const [part2, setPart2] = useState([]);
  const [addEvent, setAddEvent] = useState(false);
  useEffect(() => {
    let todaysData = [];

    if (props.testimonials && props.testimonials.length > 0) {
      todaysData = [...props.testimonials];
    }

    const paginated =
      todaysData && todaysData.slice((activePage - 1) * 5, activePage * 5);
    setTotalPages(Math.ceil(todaysData.length / 5));
    setData(paginated);
  }, [props.testimonials, activePage]);
  useEffect(() => {
    if (data && data.length > 0) {
      let part1 = [];
      let part2 = [];
      const middleWareArray = [...data];
      const middleIndex = Math.ceil(middleWareArray.length / 2);

      part1 = middleWareArray.splice(0, middleIndex);
      part2 = middleWareArray.splice(-middleIndex);

      part1 = part1.sort(
        (a, b) => b.modifiedAt.toDate() < a.modifiedAt.toDate()
      );
      part2 = part2.sort(
        (a, b) => b.modifiedAt.toDate() < a.modifiedAt.toDate()
      );
      setPart1(part1);
      setPart2(part2);
    }
  }, [data]);
  const handleAddEventModal = () => {
    setAddEvent(!addEvent);
  };

  if (!props.auth.isLoaded) {
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
  } else if (
    props.auth.isLoaded &&
    (props.auth.email === "csanicknaudin@gmail.com" || props.superAdmin)
  ) {
    if (data) {
      const pageChange = (not, data) => {
        setActivePage(data.activePage);
      };
      return (
        <div className="AthleteDetailsBackground cu-profile wiki-section">
          <div className="AthleteDetailsBannerBar"></div>
          <Filter
            onChange={() => setActivePage(1)}
            superAdmin={true}
            // searchQuery={handleSearch}
          />
          <div className="AthleteEventsInfoContainer common-event">
            <div
              className={`AthleteEventsGroupContainer SuperSchoolsWatch  ${
                data && (data.length === 1 ? "onlyone" : "")
              }`}
            >
              <div className="AthleteDetailsButtonContainer event-header testimonial-event-header">
                <div className="first-div">
                  <Button
                    icon="plus"
                    content="Add"
                    labelPosition="left"
                    color="green"
                    onClick={handleAddEventModal}
                  />
                </div>
                <div className="second-div"></div>
              </div>
              <div
                className={`testimonial-section  ${
                  data && (data.length < 2 ? "onlyone" : "")
                }`}
              >
                {data && data.length < 1 && (
                  <p className="not-found cu-center">
                    There's No Data Right Now
                  </p>
                )}
                {data && part1 && part1.length > 0 && data.length > 0 && (
                  <div className="testimonial-col">
                    {part1.map((testimonial, id) => (
                      <TestimonialCard
                        edit={props.superAdmin}
                        data={testimonial}
                        key={id}
                      />
                    ))}
                  </div>
                )}
                {data && part2 && part2.length > 0 && data.length > 0 && (
                  <div className="testimonial-col">
                    {part2.map((testimonial, id) => (
                      <TestimonialCard
                        edit={props.superAdmin}
                        data={testimonial}
                        key={id}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* pagination and pages show */}
          {totalPages > 1 && (
            <div className="AthleteSearchDetail AthletePagination justify-center">
              <Pagination
                onPageChange={pageChange}
                activePag={activePage}
                firstItem={null}
                lastItem={null}
                prevItem={{ content: <Icon name="angle left" />, icon: true }}
                nextItem={{
                  content: <Icon name="angle right" />,
                  icon: true,
                }}
                pointing
                secondary
                totalPages={totalPages}
              />
            </div>
          )}
          {/* AddSchoolsToWatch */}
          {addEvent && <Add open={addEvent} close={() => setAddEvent(false)} />}
        </div>
      );
    } else
      return (
        <div className="SpinnerBackground">
          <div className="SpinnerContainer">
            <Loader size="large" active inline="centered" />
          </div>
        </div>
      );
  } else if (props.auth.isLoaded && !props.auth.email) {
    return <Redirect to={`/login`} />;
  } else if (
    props.auth.isLoaded &&
    props.auth.email &&
    (props.auth.email !== "csanicknaudin@gmail.com" || props.superAdmin)
  ) {
    return <Redirect to={`/testimonials`} />;
  }
  return null;
};

const mapStateToProps = (state) => {
  let testimonials = [];
  const testimonialData = state.firestore.ordered.testimonial;
  const athletesData = state.firestore.data.adminAthletes;
  if (
    testimonialData &&
    athletesData &&
    testimonialData.length > 0 &&
    Object.keys(athletesData).length > 0
  ) {
    testimonials = testimonialData.map((e) => {
      let data = null;

      if (e.player && athletesData[e.player]) {
        const athlete = athletesData[e.player];
        data = {
          ...e,
          playerCustomURL: athlete.customUrl,
          playerName: `${athlete.firstName} ${athlete.lastName}`,
        };
      }
      return data;
    });
  }

  // advocateWikiOrder

  return {
    testimonials,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "testimonial",
        orderBy: ["modifiedAt", "desc"],
      },
      {
        collection: "adminAthletes",
      },
    ];
    return firestoreArray;
  })
)(SuperSchoolsWatch);
